import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function EditButton(props) {
  return (
    <Link
      className="btn btn-default"
      to={`/${props.dealerId}/outreach/${props.templateId}`}
    >
      Edit
    </Link>
  );
}

EditButton.propTypes = {
  dealerId: PropTypes.string,
  templateId: PropTypes.string,
};

export default EditButton;
